import lookup from 'country-code-lookup';

export const formatPostalCode = (postalCode?: string | null) => {
  return postalCode ?? 'N/A';
};

export const formatCountryCode = (countryCode: string) => {
  const result = lookup.byIso(countryCode);
  return result ? result.country : 'N/A';
};
